<template>
  <div class="message-row" :class="{ 'message-row--user': isUser, 'message-row--ai': !isUser }">
    <!-- User Avatar -->
<!--    <div v-if="isUser" class="user-avatar">
      <el-avatar :size="32" style="background: linear-gradient(135deg, #667eea, #764ba2); flex-shrink: 0;">
        <el-icon><User /></el-icon>
      </el-avatar>
    </div>-->
    <!-- AI Avatar -->
<!--    <div v-if="!isUser" class="ai-avatar">
      <el-image style="width: 24px;height: 24px;" src="images/logo_62.png"></el-image>
    </div>-->

    <div class="message-body">
      <!-- AI: name + time -->
<!--      <div v-if="!isUser" class="message-meta">
        <span class="sender-name">小安</span>
      </div>-->

      <!-- Content -->
      <div class="message-content" :class="{ 'content--user': isUser, 'content--ai': !isUser }">
        <!-- User: plain text -->
        <template v-if="isUser">
          <div class="user-text">{{ message.content }}</div>
        </template>

        <!-- AI: markdown rendered -->
        <template v-else>
          <div
              class="ai-markdown"
              :class="{ streaming: message.isStreaming }"
              v-html="htmlContent"
          />
          <!-- Typing cursor -->
          <span v-if="message.isStreaming" class="typing-cursor" />
        </template>
      </div>

      <!-- Actions (only when not streaming) -->
      <div v-if="!message.isStreaming" class="message-actions">
        <button class="action-btn" title="复制" @click="copyMessage">
          <el-icon><CopyDocument /></el-icon>
          <span>复制</span>
        </button>
        <button v-if="!isUser && isLast" class="action-btn" title="重新生成" @click="emit('regenerate')">
          <el-icon><RefreshRight /></el-icon>
          <span>重新生成</span>
        </button>
      </div>
    </div>


  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, watch} from 'vue'
import type { Message } from '@/types'
import { renderMarkdown } from '@/utils/helpers'
import { ElMessage } from 'element-plus'

const props = defineProps<{
  message: Message
  isLast: boolean
}>()

const emit = defineEmits<{
  regenerate: []
}>()

const isUser = computed(() => props.message.role === 'user')
// 清理内容：去除思考标签和多余空白
const cleanContent = computed(() => {
  let content = props.message.content
  if (!isUser.value) {
     // 去除 <think> 标签及其内容
    content = content.replace(/<think>[\s\S]*?<\/think>/g, '')
    // 只清理首尾空白，保留中间的换行符等格式
    content = content.trim()
  }
  return content
})
const htmlContent = computed(() => {
  const cleaned = cleanContent.value
  console.log('🎨 MessageItem 渲染内容长度:', cleaned.length)
  console.log('🎨 前100字符:', cleaned.slice(0, 100))
  return renderMarkdown(cleaned)
})
// 监听内容变化
watch(() => props.message.content, (newContent) => {
  console.log('📩 MessageItem 收到新内容，长度:', newContent?.length)
  console.log('📩 清理后内容:', cleanContent.value?.slice(0, 100))
}, { immediate: true })

function copyMessage() {
  navigator.clipboard.writeText(props.message.content)
  ElMessage({ message: '已复制到剪贴板', type: 'success', duration: 1500 })
}

function formatTime(date: Date) {
  return new Date(date).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
}
</script>

<style scoped>
.message-row {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  animation: fadeSlideIn 0.25s ease-out;
}

.message-row--user {
  flex-direction: row-reverse;
}

.message-row--ai {
  flex-direction: row;
}

.ai-avatar,
.user-avatar {
  flex-shrink: 0;
  padding-top: 2px;
}

.message-body {
  flex: 1;
  min-width: 0;
  max-width: 80%;
}

.message-row--user .message-body {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.message-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.sender-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.message-time {
  font-size: 11px;
  color: #aaa;
}

/* Content bubbles */
.message-content { display: inline-block; max-width: 100%; }

.content--user {
  background: #F1F8FF;
  border-radius: 16px 4px 16px 16px;
  padding: 10px 15px;
}
.user-text {
  font-size: 16px;
  color: #1a1a1e;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.content--ai {
  display: block;
}

/* Markdown styles */ .ai-markdown { font-size: 16px; color: #1a1a1e; line-height: 1.75; word-break: break-word; }
.ai-markdown :deep(p) { margin-bottom: 10px; } .ai-markdown :deep(p:last-child) { margin-bottom: 0; } .ai-markdown :deep(h1), .ai-markdown :deep(h2), .ai-markdown :deep(h3) { font-weight: 700; margin: 16px 0 8px; color: #111; } .ai-markdown :deep(h1) { font-size: 20px; } .ai-markdown :deep(h2) { font-size: 17px; } .ai-markdown :deep(h3) { font-size: 15px; }
.ai-markdown :deep(strong) { font-weight: 700; color: #111; } .ai-markdown :deep(em) { font-style: italic; color: #555; }
.ai-markdown :deep(ul.md-list), .ai-markdown :deep(ol.md-ordered-list) { margin: 12px 0; padding-left: 24px; }
.ai-markdown :deep(ul.md-list li), .ai-markdown :deep(ol.md-ordered-list li) { margin-bottom: 6px; line-height: 1.7; }
.ai-markdown :deep(blockquote) { margin: 12px 0; padding: 8px 12px; border-left: 4px solid #4e6ef2; background: #f5f7ff; border-radius: 4px; color: #555; }
.ai-markdown :deep(hr) { margin: 20px 0; border: none; border-top: 1px solid #e0e0e0; }
.ai-markdown :deep(table) { width: 100%; border-collapse: collapse; margin: 12px 0; font-size: 14px; }
.ai-markdown :deep(table th) { background: #f5f7ff; font-weight: 600; padding: 10px 12px; border: 1px solid #e0e0e0; text-align: left; }
.ai-markdown :deep(table td) { padding: 10px 12px; border: 1px solid #e0e0e0; }
.ai-markdown :deep(table tr:nth-child(even)) { background: #fafafa; }
.ai-markdown :deep(.inline-code) { background: #f5f5f5; padding: 2px 6px; border-radius: 4px; font-family: 'JetBrains Mono', 'Fira Code', monospace; font-size: 13px; color: #e96900; }
.ai-markdown :deep(.code-block-wrap) { background: #1e1e2e; border-radius: 10px; overflow: hidden; margin: 12px 0; font-size: 13px; } .ai-markdown :deep(.code-block-header) { display: flex; align-items: center; justify-content: space-between; padding: 8px 14px; background: #2a2a3e; color: rgba(255, 255, 255, 0.6); font-size: 12px; font-family: monospace; } .ai-markdown :deep(.copy-code-btn) { background: rgba(255, 255, 255, 0.1); border: none; color: rgba(255, 255, 255, 0.7); padding: 2px 10px; border-radius: 5px; cursor: pointer; font-size: 12px; transition: background 0.15s; } .ai-markdown :deep(.copy-code-btn:hover) { background: rgba(255, 255, 255, 0.2); } .ai-markdown :deep(pre) { padding: 14px; overflow-x: auto; } .ai-markdown :deep(code) { font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace; color: #e2e8f0; line-height: 1.65; }
.ai-markdown :deep(.md-gap) { height: 8px; display: block; }
.ai-markdown :deep(a.markdown-link) {
  color: #4e6ef2;
  text-decoration: none;
  border-bottom: 1px solid rgba(78, 110, 242, 0.3);
  transition: all 0.15s;
  cursor: pointer;
}

.ai-markdown :deep(a.markdown-link:hover) {
  color: #3a56d4;
  border-bottom-color: #3a56d4;
  background-color: rgba(78, 110, 242, 0.1);
  padding: 2px 4px;
  border-radius: 4px;
}
/* Typing cursor */ .typing-cursor { display: inline-block; width: 2px; height: 16px; background: #4e6ef2; border-radius: 1px; margin-left: 2px; vertical-align: middle; animation: blink 0.8s step-end infinite; }
/* Message actions */ .message-actions { display: flex; align-items: center; gap: 4px; margin-top: 8px; opacity: 0; transition: opacity 0.2s; } .message-row:hover .message-actions { opacity: 1; }
.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  border: none;
  background: transparent;
  color: #999;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.15s;
}
.action-btn:hover { background: #f0f2f5; color: #555; }

.action-time {
  margin-left: auto;
  font-size: 11px;
  color: #ccc;
}

/* Animations */
@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>
